module.exports = __webpack_public_path__ + "static/media/etims.15667652.jpg";